'use client';

import { Provider } from 'jotai';
import type { PropsWithChildren, ReactNode } from 'react';
/**
 * Currently this is getting placed in the global layout
 *
 * If we want to start rehydrating things manually, we may need to move to a global template
 *
 * See: https://github.com/pmndrs/jotai/discussions/2337
 **/
export function JotaiWrapper({ children }: PropsWithChildren): ReactNode {
	return (
		<>
			<Provider>{children}</Provider>
		</>
	);
}
